import React from 'react';
import classnames from 'classnames';
import addCommas from 'app/libraries/utils/add-comma';

interface Props {
  label: React.ReactNode;
  onClick: (e: React.MouseEvent) => void;
  isActive: boolean;
  count?: number;
}

function prettifyCount(count: number) {
  if (count === 50000) {
    return '+50K';
  } else {
    return addCommas(count);
  }
}

const FolderButton: React.FC<Props> = ({ label, onClick, isActive, count = 0 }) => (
  <div className={classnames('filter', { active: isActive })} onClick={onClick}>
    {label} {count > 0 && isActive && <span className="count">({prettifyCount(count)})</span>}
  </div>
);

export default FolderButton;
